import InitialLandingPage from "./InitialLandingPage";

export default InitialLandingPage;
